var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-sm mb-1 text-capitalize text-body font-weight-bold",class:_vm.spacing},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }